import {
  ApiDeleteProductFromMyWishlistRequestedAction,
  apiDeleteProductFromMyWishlistFailed,
  apiDeleteProductFromMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/deleteProductFromMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import deleteProductFromMyWishlistAction from '@spa/lib/actions/wishlists/deleteProductFromMyWishlistAction';
import logger from '@spa/lib/logger';

function* deleteProductFromMyWishlistApiSaga({
  payload: { actionId: requestedActionId, input, parentActionId }
}: ApiDeleteProductFromMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(
      deleteProductFromMyWishlistAction,
      'deleteProductFromMyWishlistAction',
      input
    );

    if (result.__typename === 'DeleteProductFromMyWishlistSucceededResult') {
      yield* put(
        apiDeleteProductFromMyWishlistSucceeded({ parentActionId, input, requestedActionId })
      );
    } else {
      yield* put(
        apiDeleteProductFromMyWishlistFailed({
          error: result.error,
          parentActionId,
          requestedActionId
        })
      );
    }
  } catch (error) {
    logger.error(error, 'Error deleting product from my wishlist');

    yield* put(
      apiDeleteProductFromMyWishlistFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default deleteProductFromMyWishlistApiSaga;
